import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BellOutline } from '../../assets/svgs/icons'
import { TimelineActionsService } from '../../services'
import { useAuth } from '../../hooks/useAuth'
import NotificationModal from '../Header/notificationModal'
import styles from './styles.module.css'

const hasStoredAuthToken = () => {
  const rawToken = window.localStorage.getItem('token')

  if (!rawToken || rawToken === 'null') {
    return false
  }

  try {
    const parsedToken = JSON.parse(rawToken)
    return Boolean(parsedToken)
  } catch {
    return Boolean(rawToken)
  }
}

function NotificationBellButton({
  small = false,
  menuPlacement = 'bottom',
  dropdownAlign = 'end',
}) {
  const { userData } = useAuth()
  const { i18n } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const [notificationCount, setNotificationCount] = useState(0)
  const wrapperRef = useRef(null)

  useEffect(() => {
    if (!userData || !hasStoredAuthToken()) {
      setNotificationCount(0)
      return
    }

    let isMounted = true

    const loadNotificationCount = async () => {
      try {
        const language = i18n.language === 'en' ? 'en' : 'ptBR'
        const { data } = await TimelineActionsService.getTimelineActionAllData(
          language,
          1,
          9,
        )

        if (isMounted) {
          setNotificationCount(Array.isArray(data) ? data.length : 0)
        }
      } catch {
        if (isMounted) {
          setNotificationCount(0)
        }
      }
    }

    loadNotificationCount()

    return () => {
      isMounted = false
    }
  }, [userData, i18n.language])

  useEffect(() => {
    if (!isOpen) {
      return
    }

    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  if (!userData) {
    return null
  }

  const badgeLabel =
    notificationCount > 9 ? '9+' : String(notificationCount)

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <button
        type="button"
        className={`${styles.actionButton} ${small ? styles.actionButtonSmall : ''} ${isOpen ? styles.actionButtonOpen : ''}`}
        onClick={() => setIsOpen((current) => !current)}
        aria-label="Notifications"
      >
        <BellOutline color="#8A8A8A" width={small ? 18 : 20} height={small ? 18 : 20} />
        {notificationCount > 0 && (
          <span className={styles.badge}>{badgeLabel}</span>
        )}
      </button>

      {isOpen && (
        <div
          className={`${styles.dropdownContainer} ${menuPlacement === 'top' ? styles.dropdownContainerTop : ''} ${dropdownAlign === 'start' ? styles.dropdownContainerAlignStart : ''} ${dropdownAlign === 'outside' ? styles.dropdownContainerAlignOutside : ''}`}
        >
          <NotificationModal floating onClose={() => setIsOpen(false)} />
        </div>
      )}
    </div>
  )
}

export default NotificationBellButton
